/**
 * A pipe for showing HTML content using domsanitizer
 * Ex: <div [innerHtml]="html | safeHtml"></div>
 */
import {DomSanitizer} from '@angular/platform-browser';
import {PipeTransform, Pipe} from '@angular/core';

@Pipe({
    name: 'safeHtml',
    standalone: false
})
export class SafeHtmlPipe implements PipeTransform {
    constructor(private sanitized: DomSanitizer) {
    }

    transform(value: any) {
        return this.sanitized.bypassSecurityTrustHtml(value);
    }
}
